(function () {
    'use strict';

    angular
        .module('oddCampaignModule')
        .controller('oddCampaignQuestionnaireFullController', Controller);

    Controller.$inject = ['$scope', '$state', 'notificationService', 'oddCampaignService'];

    function Controller($scope, $state, notificationService, oddCampaignService) {
        var campaign = $scope.boxContext.campaign;

        $scope.remove = remove;

        $scope.ctrlCtxt = {};

        function remove() {
            $scope.ctrlCtxt.isLoading = true;

            return oddCampaignService.deleteQuestionnaire(campaign.ODDBusinessUnitID, campaign.ODDExternalPartyID,
                    campaign.ODDCampaignID, $scope.boxModel.ODDCampaignQuestionnaireID).then(function () {

                notificationService.notify('Questionnaire has been deleted');

                $state.go('odd.externalPartyEdit.campaign', {}, { reload: true });
            }).finally(function () {
                $scope.ctrlCtxt.isLoading = false;
            });
        }
    }

})();